import { useTranslation } from 'react-i18next';
import getResetPasswordSchema from './getResetPasswordSchema';
import ResetPasswordForm from './ResetPasswordForm';
import useResetPasswordSubmit from './useResetPasswordSubmit';
import FormWithProvider from '@/components/forms/form/Form';
import { PublicFormTitle } from '@/pages/_layouts/publicLayout/publicForm.styles';
import type {
  CompleteResetPasswordResponse,
  PasswordRequirements,
} from '@/services/forgot-password.types';

interface ResetPasswordSectionProps {
  ott: string;
  passwordRequirements?: PasswordRequirements;
  onCompleted: (response: CompleteResetPasswordResponse) => void;
}

const ResetPasswordSection = ({
  ott,
  passwordRequirements,
  onCompleted,
}: ResetPasswordSectionProps) => {
  const { t } = useTranslation();
  const { handleSubmitResetPassword, clearErrors, errorMessage, isSubmitting } =
    useResetPasswordSubmit({ ott, onCompleted });

  return (
    <FormWithProvider
      horizontal
      onSubmit={handleSubmitResetPassword}
      resolver={getResetPasswordSchema(passwordRequirements)}
      defaultValues={{ password: '', confirmPassword: '' }}
    >
      <PublicFormTitle data-testid="reset-password-title">
        {t('pageForgotPassword.resetTitle')}
      </PublicFormTitle>
      <ResetPasswordForm
        clearErrors={clearErrors}
        errorMessage={errorMessage}
        isSubmitting={isSubmitting}
      />
    </FormWithProvider>
  );
};

export default ResetPasswordSection;
